/** Цвет фона/хедера в формате hex (Telegram WebApp принимает только #rrggbb) */
export const TELEGRAM_PRIMARY_HEX = "#1a2026";

export function initTelegramUi() {
  const tg = window.Telegram?.WebApp;
  if (!tg) return;
  try {
    tg.ready();
    tg.expand();
  } catch {
    // ignore
  }
  try {
    tg.setHeaderColor(TELEGRAM_PRIMARY_HEX);
  } catch {
    // ignore
  }
  try {
    tg.setBackgroundColor?.(TELEGRAM_PRIMARY_HEX);
  } catch {
    // ignore
  }
}

